import { useState, forwardRef, useImperativeHandle } from "react";
import { Dialog } from "@xp-design/mobile";
import style from "./style.module.less";
import img_share_help from "../../assets/img_share_help.png";
import icon_close from "../../assets/icon_close.png";
import { processOssImage } from "@/utils/image";

interface HelpDialogProps {
  onClose: () => void;
  prizeData: {
    isWin: boolean;
    productName?: string;
    prizeUrl?: string;
    winBg?: string;
    noWinBg?: string;
    singleDistributionCount?: number;
  };
}

const HelpDialog = forwardRef<
  {
    onOpen: () => void;
    onClose: () => void;
  },
  HelpDialogProps
>(({ onClose }, ref) => {
  const [visible, setVisible] = useState(false);

  const handleOpen = () => {
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
    onClose?.();
  };

  useImperativeHandle(ref, () => ({
    onOpen: handleOpen,
    onClose: handleClose,
  }));

  return (
    <Dialog
      visible={visible}
      onClose={() => setVisible(false)}
      getContainer={null}
      closeOnMaskClick
      bodyClassName={style["customDialogBody"]}
      content={
        <>
          <div
            className={style["helpDialog"]}
            style={{
              backgroundImage: `url(${processOssImage(img_share_help)})`,
              backgroundSize: "100% 100%",
            }}
          >
            <div className={style["p1"]}>助力成功</div>
            <div className={style["p2"]}>您已成功为好友助力</div>
            <div className={style["btn"]} onClick={() => setVisible(false)}>
              确定
            </div>
            <div className={style["close_outer"]}>
              <img
                className={style["icon_close"]}
                src={icon_close}
                onClick={() => setVisible(false)}
              />
            </div>
          </div>
        </>
      }
    ></Dialog>
  );
});

export default HelpDialog;
